import React from "react";
import Profile00 from "../images/Jason.webp";
import Profile01 from "../images/Othell.webp";
import Award from "../images/Award.webp";
import Badge from "../images/Badge.png";

const AboutUs = () => {
  return (
    <div class="container">
      <div class="row about">
        <div class="col-sm-3 about">
          <div class="card" style={{ width: "100%" }}>
            <img
              class="card-img-top profile00"
              src={Profile00}
              alt="Jason in studio"
            />
            <div class="card-body">
              <h4 class="card-title">Dr. Jason D. Gordon</h4>
              <p class="card-text-profile">
                Dr. Jason D. Gordon is a board-certified mental health provider
                with a passion for helping individuals navigate life's
                challenges. A proud Navy and Air Force veteran, Dr. Gordon
                brings a unique perspective to his work, combining his military
                background with a deep commitment to mental health advocacy.
              </p>
              <p class="card-text-profile">
                Currently, Dr. Gordon serves as a mental health provider in the
                Oncology department at a local military treatment facility,
                where he provides crucial support to patients and their
                families. He is also an esteemed part-time professor at the
                University of Southern California (USC) in Los Angeles, where he
                shares his expertise with the next generation of mental health
                professionals.
              </p>
              <p class="card-text-profile">
                In addition to his clinical work, Dr. Gordon sits as an advisor
                to a consulting firm based in Los Angeles and Salt Lake City,
                UT. He is also an active member of the board of a nonprofit in
                San Diego that provides mental health and supportive services to
                active-duty service members, veterans, and their families.
              </p>
              <p class="card-text-profile">
                Driven by a strong compassion for helping others through tough
                times, Dr. Gordon created the G2 Radio Network and the Mood Food
                Podcast. The network plays a mix of music and self-help
                programming designed to uplift, encourage, and empower
                listeners, especially those facing difficult moments. Dr.
                Gordon's love for radio broadcasting began in the late 90s, and
                since then, he has used the airwaves as a powerful tool to
                connect with people and inspire positive change.
              </p>
              <p class="card-text-profile">
                In his personal life, Dr. Gordon enjoys spending quality time
                with his husband, Othell. Together, they enjoy traveling and
                being active members of their community. Whether in the therapy
                room, in the classroom, or behind the microphone, Dr. Gordon
                remains committed to helping others improve their lives and
                navigate life's most difficult moments with hope and resilience.
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-3 about">
          <div class="card" style={{ width: "100%" }}>
            <img
              class="card-img-top profile01"
              src={Profile01}
              alt="Othell"
            />
            <div class="card-body">
              <h4 class="card-title">Othell Garmon</h4>
              <p class="card-text-profile">
                Othell Garmon is a seasoned professional who served as an
                Electronic Maintenance Supervisor in the US Army for 20 years.
                He possesses extensive experience and technical expertise,
                particularly in working with computers.
              </p>
              <p class="card-text-profile">
                Mr. Garmon holds a bachelor's degree in web development,
                providing him with a robust foundation in designing, building,
                and maintaining websites and web applications. Additionally, he
                has earned a master's degree in information technology, which
                has further enhanced his knowledge and skills in advanced topics
                such as network security, database management, and IT project
                management.
              </p>
              <p class="card-text-profile">
                In addition to his academic qualifications, Mr. Garmon has
                obtained certifications in A+, Network+, Security+, and
                PenTest+. These certifications attest to his proficiency in
                essential IT skills, including hardware and software
                troubleshooting, network infrastructure, cybersecurity, and
                penetration testing.
              </p>
              <p class="card-text-profile">
                Outside of his professional endeavors, Mr. Garmon enjoys
                spending time and traveling with his husband, Jason. He also
                dedicates some of his free time to monitoring and creating
                programs for the radio station.
              </p>
            </div>
          </div>
        </div>
      </div>
      

      <div class="row row-cols-1 row-cols-md-4 g-4 award">
        <div class="col">
          <div class="card h-95">
            <a
              href="https://www.communicatorawards.com/winners/winners-gallery/?event=1088&award=9&search=G2%20Radio%20Network&id=543522"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Badge} class="card-img-top" alt="Award Image." />
              <img src={Award} class="card-img-top" alt="Award Image." />
              <div class="card-body">
                <h2 class="card-title">Distinction Award 2025</h2>
                <h5 class="card-title">Campaign-PSA Campaign or Series</h5>
                <h6 class="card-title">Breast Cancer Awareness Month Spot</h6>
                <div class="d-grid"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-95">
            <a
              href="https://www.communicatorawards.com/winners/winners-gallery/?event=1088&award=9&search=G2%20Radio%20Network&id=544780"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Badge} class="card-img-top" alt="Award Image." />
              <img src={Award} class="card-img-top" alt="Award Image."></img>
              <div class="card-body">
                <h2 class="card-title">Distinction Award 2025</h2>
                <h5 class="card-title">General-360 Brand Experience</h5>
                <h6 class="card-title">
                  G2 Radio Network Television Interview on CBS 8 San Diego
                </h6>
                <div class="d-grid-text"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-95">
            <a
              href="https://www.communicatorawards.com/winners/winners-gallery/?event=1088&award=9&search=G2%20Radio%20Network&id=544780"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Badge} class="card-img-top" alt="Award Image." />
              <img src={Award} class="card-img-top" alt="Award Image."></img>
              <div class="card-body">
                <h2 class="card-title">Distinction Award 2025</h2>
                <h5 class="card-title">Features-Best Brand Collaboration</h5>
                <h6 class="card-title">
                  G2 Radio Network Television Interview on CBS 8 San Diego
                </h6>
                <div class="d-grid-text"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col">
          <div class="card h-95">
            <a
              href="https://www.communicatorawards.com/winners/winners-gallery/?event=1088&award=9&search=G2%20Radio%20Network&id=544780"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Badge} class="card-img-top" alt="Award Image." />
              <img src={Award} class="card-img-top" alt="Award Image."></img>
              <div class="card-body">
                <h2 class="card-title">Distinction Award 2025</h2>
                <h5 class="card-title">General-Product Launch Activation</h5>
                <h6 class="card-title">
                  G2 Radio Network Television Interview on CBS 8 San Diego
                </h6>
                <div class="d-grid-text"></div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="video-container">
        <iframe
          class="video"
          width="1300"
          height="600"
          src="https://www.youtube.com/embed/nJCtvRpC3q8?si=VOZWOnfgRAc0ZNMu"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
};

export default AboutUs;
